// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"94b1adda","455":"401a4dad","977":"dca9e617"}[chunkId] + ".chunk.js";
};